import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { FormulationsContainer, Wrapper } from "./styles"
import FormulationTextBlock from "./FormulationTextBlock"

const Formulations = ({ item }) => {
  const data = useStaticQuery(FORMULATIONS_QUERY)

  return (
    <FormulationsContainer>
      <Wrapper>
        <h2 className="title">
          {data.agilityV2FormulationsListing.customFields.title}
        </h2>
        <h5 className="sub-title">
          {data.agilityV2FormulationsListing.customFields.subTitle}
        </h5>
        <div className="compounds">
          <div className="compound">
            <div className="circle blue1"></div>
            <p>
              {data.agilityV2FormulationsListing.customFields.cannabinoidsTitle}
            </p>
          </div>
          <div className="compound">
            <div className="circle blue2"></div>
            <p>
              {data.agilityV2FormulationsListing.customFields.terpenesTitle}
            </p>
          </div>
          <div className="compound">
            <div className="circle blue3"></div>
            <p>
              {data.agilityV2FormulationsListing.customFields.flavanoidsTitle}
            </p>
          </div>
          <div className="compound">
            <div className="circle blue4"></div>
            <p>
              {
                data.agilityV2FormulationsListing.customFields
                  .mushroomCompoundsTitle
              }
            </p>
          </div>
        </div>
        <div className="formulations">
          {data.agilityV2FormulationsListing.linkedContent_formulationsList
            .reverse()
            .map((formulation, i) => (
              <div className="formulation" key={i}>
                <h3>{formulation.customFields.title}</h3>
                <div className="img-container">
                  <Img
                    className="img"
                    fluid={
                      formulation.customFields.imageLocalImg.childImageSharp
                        .fluid
                    }
                    alt={formulation.customFields.title}
                  />
                </div>
                <FormulationTextBlock text={formulation.customFields.text} />
              </div>
            ))}
        </div>
      </Wrapper>
    </FormulationsContainer>
  )
}

const FORMULATIONS_QUERY = graphql`
  query {
    agilityV2FormulationsListing {
      customFields {
        title
        subTitle
        cannabinoidsTitle
        terpenesTitle
        flavanoidsTitle
        mushroomCompoundsTitle
      }
      linkedContent_formulationsList {
        customFields {
          text
          title
          imageLocalImg {
            childImageSharp {
              fluid(quality: 100, maxWidth: 500) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`

export default Formulations
